<pr-table
  [tableData]="_tableData"
  [actionsTemplate]="actionsTemplate"
  [swiperMinWidth]="swiperMinWidth"
  [clazz]="variant === 'ASSET_SUPPORT' ? 'asset-support' : ''"
>
  <!-- Actions template -->
  <ng-template #actionsTemplate let-item>
    @if (hasConfirmButton) {
      <pr-button-confirm
        [display]="variant === 'DEFAULT' ? 'danger' : ''"
        variant="colored"
        [size]="confirmbtnVariant === 'DEFAULT' ? 'sm' : ''"
        [clazz]="
          'pr-toolbar-button last ' +
          (variant === 'ASSET_SUPPORT' ? 'confirm-lg' : '')
        "
        [icon]="variant === 'ASSET_SUPPORT' ? 'sp-trash' : 'delete_forever'"
        [iconViewBoxWidth]="variant === 'ASSET_SUPPORT' ? '23' : ''"
        [iconViewBoxHeight]="variant === 'ASSET_SUPPORT' ? '23' : ''"
        title="Suppression"
        comment="Toute suppression est définitive, les données seront perdues."
        labelConfirm="Supprimer"
        labelCancel="Annuler"
        (onConfirm)="_deleteItem(item)"
      >
        Êtes-vous sûr(e) de vouloir supprimer <em>“{{ item.name }}”</em>
      </pr-button-confirm>
    }
  </ng-template>
</pr-table>
@if (hasAddButton) {
  <pr-table-form-add
    [options]="formatedListOption"
    (optionSelected)="onOptionSelected($event)"
    (click)="onSelectClick.emit($event)"
    [buttonLabel]="addButtonLabel"
    [buttonIcon]="variant === 'ASSET_SUPPORT' ? 'sp-pen' : 'add'"
  ></pr-table-form-add>
}
